var _ellipse, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 684,
    height: 191,
    viewBox: "0 0 684 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_60_99",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -148,
    y: -31,
    width: 712,
    height: 338
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.995,
    cy: 186.607,
    rx: 345.995,
    ry: 186.607,
    transform: "matrix(0.920789 0.390061 -0.841853 0.539707 46.5537 -97.5742)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_60_99)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7518,
    cy: 41.9342,
    rx: 77.7518,
    ry: 41.9342,
    transform: "matrix(0.920789 0.390061 -0.841853 0.539707 49.9629 163.219)",
    fill: "#E2EAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.302 312.361C285.706 330.053 235.994 337.623 173.974 333.158C112.509 328.732 42.1936 312.588 -21.8258 285.469C-85.8453 258.349 -130.534 225.775 -151.401 195.323C-172.457 164.596 -168.391 137.69 -140.795 119.998C-113.199 102.306 -63.4874 94.7364 -1.46744 99.2014C59.9976 103.627 130.313 119.771 194.333 146.89C258.352 174.01 303.041 206.584 323.908 237.036C344.964 267.763 340.898 294.669 313.302 312.361Z",
    stroke: "#E2EAEE",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.391 275.967C211.493 286.159 181.988 291.013 143.181 288.219C104.929 285.465 60.8328 275.379 20.5372 258.31C-19.7584 241.24 -47.7109 220.804 -60.6973 201.853C-73.8721 182.626 -70.7816 166.583 -54.8836 156.391C-38.9857 146.199 -9.48055 141.345 29.3263 144.139C67.5783 146.893 111.675 156.979 151.97 174.049C192.266 191.119 220.218 211.554 233.205 230.505C246.379 249.732 243.289 265.775 227.391 275.967Z",
    stroke: "#E2EAEE",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.634 347.238C356.827 372.117 287.75 382.29 203.484 376.223C119.773 370.197 24.3305 348.246 -62.4243 311.495C-149.179 274.745 -209.907 230.539 -238.326 189.065C-266.934 147.316 -261.935 110 -223.128 85.1206C-184.321 60.2418 -115.244 50.069 -30.9786 56.1356C52.7323 62.1622 148.175 84.1125 234.93 120.863C321.685 157.614 382.412 201.82 410.832 243.294C439.44 285.042 434.44 322.359 395.634 347.238Z",
    stroke: "#E2EAEE",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.546 383.631C431.041 416.01 341.758 428.899 234.279 421.161C127.355 413.463 5.6923 385.454 -104.786 338.654C-215.265 291.853 -292.729 235.509 -329.029 182.535C-365.518 129.286 -359.544 81.1055 -309.039 48.727C-258.534 16.3485 -169.25 3.45951 -61.7714 11.1973C45.1527 18.8951 166.815 46.904 277.294 93.7045C387.772 140.505 465.236 196.849 501.536 249.824C538.025 303.073 532.051 351.253 481.546 383.631Z",
    stroke: "#E2EAEE",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.878 418.508C502.162 458.074 393.514 473.566 263.789 464.227C134.619 454.927 -12.1703 421.112 -145.384 364.681C-278.598 308.249 -372.101 240.273 -415.954 176.277C-459.995 112.006 -453.087 53.4154 -391.371 13.8497C-329.655 -25.716 -221.007 -41.2079 -91.2821 -31.8686C37.8879 -22.5692 184.677 11.2458 317.891 67.6773C451.105 124.109 544.608 192.086 588.461 256.081C632.502 320.352 625.594 378.943 563.878 418.508Z",
    stroke: "#E2EAEE",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.051 450.353C567.099 496.481 440.77 514.35 290.734 503.548C141.252 492.786 -28.4793 453.67 -182.452 388.445C-336.424 323.22 -444.571 244.622 -495.319 170.563C-546.256 96.2293 -538.495 28.1335 -466.543 -17.9944C-394.592 -64.1223 -268.263 -81.9909 -118.226 -71.1893C31.2551 -60.4276 200.987 -21.3114 354.959 43.9138C508.931 109.139 617.078 187.737 667.827 261.795C718.763 336.129 711.002 404.225 639.051 450.353Z",
    stroke: "#E2EAEE",
    strokeWidth: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.7d3e5ccf8efdbccf31393759a2bb78d0.svg";
export { ForwardRef as ReactComponent };